import { AgentClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiAgentClient = new AgentClient(defaultAxiosInstance)
